<template>
	<div class="progress-bar-box">
		<div class="progress-bar">
			<div class="inner" :style="`width: ${percentage}%`"></div>
		</div>
		<p><span class="text" v-if="text">{{ text }}</span>({{ percentage }}%)</p>
	</div>
</template>

<script>
export default {
	name: "ProgressBarBox",
	props: {
		percentage: {
			type: Number,
			default: 0
		},
		text: {
			type: String,
		}
	}
}
</script>

<style scoped lang="scss">
.progress-bar-box {
	text-align: center;
	font-size: 14px;
	margin-bottom: 20px;
	color: var(--white-color, $whiteColor);
	&:last-child {
		margin-bottom: 0;
	}
	p {
		font-size: 12px;
	}
	.text {
		margin-right: 5px;

	}
}
.progress-bar {
	height: 10px;
	position: relative;
	width: 100%;
	margin-bottom: 8px;
	border: 1px solid var(--primary-color, $primaryColor);
	border-radius: 2px;
	overflow: hidden;

}
.inner {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	background: var(--primary-color, $primaryColor);
	transition: var(--animation-default-duration, $animationDefaultDuration);
	opacity: .6;
}
</style>